// extracted by mini-css-extract-plugin
module.exports = {"bulletGroup":"style_bulletGroup__3d7oi","bullet":"style_bullet__NNXiz"};